import { useAuthStore } from '@/stores/auth'

// Permission constants mapped to RBAC resource:action format
export const PERMISSIONS = {
  // User management
  USERS_VIEW: 'user:read',
  USERS_CREATE: 'user:create',
  USERS_EDIT: 'user:update',

  // Roles
  ROLES_VIEW: 'role:read',
  ROLES_CREATE: 'role:create',
  ROLES_EDIT: 'role:update',
  ROLES_DELETE: 'role:delete',
  /** Route/detail guard for the RBAC admin surfaces (see GS-B1). */
  ROLES_MANAGE: 'roles:manage',

  // Permissions
  PERMISSIONS_VIEW: 'permission:read',

  // Projects
  PROJECTS: 'project:read',
  PROJECTS_CREATE: 'project:create',
  PROJECTS_EDIT: 'project:update',
  PROJECTS_DELETE: 'project:delete',
  PROJECTS_SUBMIT: 'project:submit',
  PROJECTS_CANCEL: 'project:cancel',

  // Quotations
  QUOTATIONS: 'quotation:read',
  QUOTATIONS_CREATE: 'quotation:create',
  QUOTATIONS_EDIT: 'quotation:update',
  QUOTATIONS_DELETE: 'quotation:delete',
  QUOTATIONS_SUBMIT: 'quotation:submit',
  QUOTATIONS_CANCEL: 'quotation:cancel',

  // Contracts
  CONTRACTS: 'contract:read',
  CONTRACTS_CREATE: 'contract:create',
  CONTRACTS_EDIT: 'contract:update',
  CONTRACTS_DELETE: 'contract:delete',
  CONTRACTS_SUBMIT: 'contract:submit',
  CONTRACTS_CANCEL: 'contract:cancel',

  // Clients / Customers
  CLIENTS: 'customer:read',
  CLIENTS_CREATE: 'customer:create',
  CLIENTS_EDIT: 'customer:update',
  CLIENTS_DELETE: 'customer:delete',

  // CRM Leads
  LEADS: 'lead:read',
  LEADS_CREATE: 'lead:create',
  LEADS_EDIT: 'lead:update',
  LEADS_DELETE: 'lead:delete',

  // Reports
  REPORTS: 'report:read',

  // Dashboard
  DASHBOARD_VIEW: 'dashboard:view',

  // Admin
  ADMIN: 'role:read', 
  ADMIN_USERS: 'user:read',
  ADMIN_SYSTEM: 'settings:read',
  // Background jobs (erp-api RQ audit rows, tenant-scoped)
  JOBS_READ: 'jobs:read',
  JOBS_RETRY: 'jobs:retry',

  // Branches (operating units inside a tenant)
  BRANCH_LIST: 'branch:list',
  BRANCH_READ: 'branch:read',
  BRANCH_CREATE: 'branch:create',
  BRANCH_UPDATE: 'branch:update',
  BRANCH_DELETE: 'branch:delete',

  // Commercial register
  COMMERCIAL_REGISTER: 'commercial_register:read',
  
  
  
  // Daftra
  DAFTRA: 'daftra:read',

  // ERPNext
  ERPNEXT_READ: 'erpnext:read',
  ERPNEXT_SYNC: 'erpnext:sync',
  ERPNEXT_SETTINGS: 'erpnext:settings',
  
  // Settings
  BRANDING_READ: 'branding:read',
  SETTINGS_READ: 'settings:read',
  SETTINGS_MANAGE: 'settings:manage',
  SETTINGS_UPDATE: 'settings:update',

  // Tasks (project tasks module)
  TASKS_LIST: 'task:list',
  TASKS_READ: 'task:read',
  TASKS_CREATE: 'task:create',
  TASKS_UPDATE: 'task:update',
  TASKS_DELETE: 'task:delete',

  // Document templates (Template Studio)
  TEMPLATE_READ: 'template:read',
  TEMPLATE_CREATE: 'template:create',
  TEMPLATE_UPDATE: 'template:update',
  TEMPLATE_DELETE: 'template:delete',

  // Sales Orders
  SALES_ORDERS: 'sales_order:read',
  SALES_ORDERS_CREATE: 'sales_order:create',
  SALES_ORDERS_EDIT: 'sales_order:update',
  SALES_ORDERS_DELETE: 'sales_order:delete',
  SALES_ORDERS_SUBMIT: 'sales_order:submit',
  SALES_ORDERS_CANCEL: 'sales_order:cancel',

  // Inventory items
  ITEMS_VIEW: 'item:read',
  ITEMS_CREATE: 'item:create',
  ITEMS_EDIT: 'item:update',
  ITEMS_DELETE: 'item:delete',

  // Delivery notes
  DELIVERY_NOTES_VIEW: 'delivery_note:read',
  DELIVERY_NOTES_CREATE: 'delivery_note:create',
  DELIVERY_NOTES_EDIT: 'delivery_note:update',
  DELIVERY_NOTES_SUBMIT: 'delivery_note:submit',
  DELIVERY_NOTES_CANCEL: 'delivery_note:cancel',

  // Commercial register
  COMMERCIAL_REGISTER_CREATE: 'commercial_register:create',

  // Invoices
  INVOICES_VIEW: 'invoice:read',
  INVOICES_CREATE: 'invoice:create',
  INVOICES_EDIT: 'invoice:update',
  INVOICES_DELETE: 'invoice:delete',
  INVOICES_SUBMIT: 'invoice:submit',
  INVOICES_CANCEL: 'invoice:cancel',

  // Credit notes
  CREDIT_NOTES_VIEW: 'credit_note:read',
  CREDIT_NOTES_CREATE: 'credit_note:create',
  CREDIT_NOTES_EDIT: 'credit_note:update',
  CREDIT_NOTES_SUBMIT: 'credit_note:submit',
  CREDIT_NOTES_CANCEL: 'credit_note:cancel',

  // Receipt Inbox
  RECEIPT_INBOX_CREATE: 'receipt_inbox:create',
  RECEIPT_INBOX_READ: 'receipt_inbox:read',
  RECEIPT_INBOX_MATCH: 'receipt_inbox:match',

  // Support tickets
  SUPPORT_READ: 'support:read',
  SUPPORT_CREATE: 'support:create',
  SUPPORT_REPLY: 'support:reply',

  // Accounting
  ACCOUNTING_VIEW: 'account:read',
  ACCOUNTING_REPORTS: 'accounting_report:read',
  JOURNAL_LIST: 'journal_entry:list',
  SUPPLIER_LIST: 'supplier:list',
  BILL_LIST: 'bill:list',
  PAYMENT_ENTRY_LIST: 'payment_entry:list',
  TAX_CODE_LIST: 'tax_code:list',
  TAX_CODE_CREATE: 'tax_code:create',
  TREASURY_LIST: 'treasury:list',
  TREASURY_CREATE: 'treasury:create',
  TREASURY_UPDATE: 'treasury:update',
  TREASURY_DELETE: 'treasury:delete',
  FISCAL_YEAR_READ: 'fiscal_year:read',
  FISCAL_YEAR_CREATE: 'fiscal_year:create',
  FISCAL_YEAR_UPDATE: 'fiscal_year:update',
  FISCAL_YEAR_REOPEN: 'fiscal_year:reopen',
  ACCOUNT_UPDATE: 'account:update',

  // RBAC v3: finer permission codes
  GL_READ: 'gl:read',
  PAYMENT_TERM_READ: 'payment_term:read',
  PAYMENT_TERM_CREATE: 'payment_term:create',
  PAYMENT_TERM_UPDATE: 'payment_term:update',
  PAYMENT_TERM_DELETE: 'payment_term:delete',
  ORDER_LOST_REASONS_MANAGE: 'order_lost_reason:manage',
  LEAD_FIELD_OPTIONS_MANAGE: 'lead_field_option:manage',
  FILE_TYPES_MANAGE: 'file_type:manage',
  PROJECT_TYPES_MANAGE: 'project_type:manage',
  PAYMENT_READ: 'payment:read',
  PAYMENT_CREATE: 'payment:create',
  PAYMENT_UPDATE: 'payment:update',
  PAYMENT_SUBMIT: 'payment:submit',
  PAYMENT_DELETE: 'payment:delete',
  INVOICES_SEND: 'invoice:send',
  CONTRACTS_SIGN: 'contract:sign',
  COMMERCIAL_REGISTER_UPDATE: 'commercial_register:update',
  COMMERCIAL_REGISTER_DELETE: 'commercial_register:delete',
  CLIENTS_IMPORT: 'customer:import',
  CLIENTS_EXPORT: 'customer:export',
  BANK_READ: 'bank:read',
  BANK_CREATE: 'bank:create',
  BANK_UPDATE: 'bank:update',
  CURRENCY_READ: 'currency:read',
  CURRENCY_CREATE: 'currency:create',
  DIMENSION_READ: 'dimension:read',
  DIMENSION_UPDATE: 'dimension:update',
  PARTY_ACCOUNT_READ: 'party_account:read',
  PARTY_ACCOUNT_UPDATE: 'party_account:update',
  ACCOUNTING_SETTINGS_READ: 'accounting_settings:read',
  ACCOUNTING_SETTINGS_UPDATE: 'accounting_settings:update',
  BILL_SUBMIT: 'bill:submit',
  BILL_CANCEL: 'bill:cancel',
  PAYMENT_ENTRY_SUBMIT: 'payment_entry:submit',
  PAYMENT_ENTRY_CANCEL: 'payment_entry:cancel',
  TAX_CODE_UPDATE: 'tax_code:update',
  OPENING_BALANCE_CREATE: 'opening_balance:create',
  FISCAL_YEAR_CLOSE: 'fiscal_year:close',
  JOURNAL_POST: 'journal_entry:post',
  JOURNAL_CANCEL: 'journal_entry:cancel',
  DELIVERY_NOTES_STATUS: 'delivery_note:status',
  SERIAL_READ: 'serial:read',
  SERIAL_UPDATE: 'serial:update',
  DEMO_DATA_MANAGE: 'demo_data:manage',

  // Accounting create/update codes used by in-page buttons
  ACCOUNT_CREATE: 'account:create',
  JOURNAL_CREATE: 'journal_entry:create',
  PAYMENT_ENTRY_CREATE: 'payment_entry:create',
  BILL_CREATE: 'bill:create',
  SUPPLIER_CREATE: 'supplier:create',
  SUPPLIER_UPDATE: 'supplier:update',

  // WhatsApp channel
  WHATSAPP_READ: 'whatsapp:read',
  WHATSAPP_SEND: 'whatsapp:send',
  WHATSAPP_MANAGE: 'whatsapp:manage',
  WHATSAPP_ASSIGN: 'whatsapp:assign',
  WHATSAPP_REQUEST_DOCUMENT: 'whatsapp:request_document',
} as const

export type PermissionKey = keyof typeof PERMISSIONS
export type PermissionValue = typeof PERMISSIONS[PermissionKey]

const GLOBAL_GRANTS = new Set(['*', '*.all', 'admin:*'])

interface PermissionIndex {
  values: Set<string>
  grantsAll: boolean
}

// Permission checks run from templates (often per row), so avoid rescanning the
// array on every call. The store replaces the array on update, which keeps the
// identity-based cache correct.
const permissionIndexCache = new WeakMap<readonly string[], PermissionIndex>()

function indexPermissions(permissions: readonly string[]): PermissionIndex {
  const cached = permissionIndexCache.get(permissions)
  if (cached) return cached

  const index: PermissionIndex = {
    values: new Set(permissions),
    grantsAll: permissions.some((p) => GLOBAL_GRANTS.has(p)),
  }
  permissionIndexCache.set(permissions, index)
  return index
}

/** True when ``permissionName`` is granted by explicit name, resource wildcard, or global grant. */
export function matchesPermission(permissions: string[], permissionName: string): boolean {
  const { values, grantsAll } = indexPermissions(permissions)
  if (grantsAll) {
    return true
  }
  if (values.has(permissionName)) {
    return true
  }
  if (permissionName.includes(':')) {
    const resource = permissionName.split(':')[0]
    if (values.has(`${resource}:*`)) {
      return true
    }
  }
  return false
}

// Helper to check if user is super admin
export const isSuperAdmin = (): boolean => {
  const authStore = useAuthStore()
  return authStore.isSuperAdmin
}